import React, { useState } from "react";
import "./Header.css";
import logo from "../Assets/logo.svg";

import { FiMenu, FiX } from "react-icons/fi";
import { FaTwitter, FaFacebook, FaLinkedin, FaYoutube, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

import { useLocation } from "react-router-dom";
  
const Header = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="vangal-header-wrapper">

      {/* Top Section */}
      <div className="vangal-header-top">
        
        {/* Social Icons */}
        <div className="vangal-header-social">
          <FaTwitter />
          <FaFacebook />
          <FaLinkedin />
          <FaYoutube />
        </div>

        {/* Email + Phone */}
        <div className="vangal-header-contact">
          <span className="vangal-header-email">
            <FaEnvelope className="vangal-contact-icon" /> admin@vangalfarm.co.in
          </span>
          <span className="vangal-header-phone">
            <FaPhoneAlt className="vangal-contact-icon" /> 04286-234369/259
          </span>
        </div>
      </div>

      {/* Middle Section */}
      <div className="vangal-header-main">
        
        {/* Logo */}
        <div className="vangal-header-logo">
          <img src={logo} alt="Vangal Logo" />
        </div>

        {/* Desktop Navigation */}
        <nav className="vangal-header-nav">
  <ul className="vangal-header-menu">
  <li>
    <a
      href="/"
      className={location.pathname === "/" ? "active" : ""}
    >
      HOME
    </a>
  </li>

  <li>
    <a
      href="/about"
      className={location.pathname === "/about" ? "active" : ""}
    >
      ABOUT US
    </a>
  </li>

  <li>
    <a
      href="/products"
      className={location.pathname === "/products" ? "active" : ""}
    >
      PRODUCTS
    </a>
  </li>

  <li>
    <a
      href="/packages-design"
      className={location.pathname === "/packages-design" ? "active" : ""}
    >
      INFRASTRUCTURE
    </a>
  </li>


  <li>
    <a
      href="/contact"
      className={location.pathname === "/contact" ? "active" : ""}
    >
      CONTACT US
    </a>
  </li>
</ul>
</nav>

{/* Button Link */}
<a href="/brochure.pdf" target="_blank" rel="noopener noreferrer" className="vangal-header-btn">
  OUR BROCHURE
</a>


        {/* Mobile Menu Button */}
        <div
          className="vangal-header-mobile-icon"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <FiX /> : <FiMenu />}
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="vangal-mobile-menu">
          <ul>
  <li>
    <a
      href="/"
      className={location.pathname === "/" ? "active" : ""}
    >
      HOME
    </a>
  </li>

  <li>
    <a
      href="/about"
      className={location.pathname === "/about" ? "active" : ""}
    >
      ABOUT US
    </a>
  </li>

  <li>
    <a
      href="/products"
      className={location.pathname === "/products" ? "active" : ""}
    >
      PRODUCTS
    </a>
  </li>

  <li>
    <a
      href="/packages-design"
      className={location.pathname === "/packages-design" ? "active" : ""}
    >
      INFRASTRUCTURE
    </a>
  </li>

  <li>
    <a
      href="/contact"
      className={location.pathname === "/contact" ? "active" : ""}
    >
      CONTACT US
    </a>
  </li>
  <li className="vangal-mobile-btn">
<a href="/brochure.pdf" target="_blank" rel="noopener noreferrer">
 OUR BROCHURE
</a>
  </li>
</ul>
        </div>
      )}
    </header>
  );
};

export default Header;
